import { useState } from 'react';
import styled from 'styled-components';
import {
  flexBoxCenter,
  justifyContentSpaceEvenly,
  layerA180Deg,
  layerB,
} from '../../../styles/commonStyles';
import LocationDropBox from './LocationDropBox';

const SystemIdentificationChooser = ({ locations, onAdd, onEdit }) => {
  const [openLocationSelectBox, setOpenLocationSelectBox] = useState(false);

  const handleSelectedLocation = (location) => {
    if (location) onEdit(location);
  };

  return (
    <Wrapper>
      <Route onClick={onAdd}>
        <RouteIcon>+</RouteIcon>
        <RouteLabel>add new system</RouteLabel>
      </Route>

      <RouteContainer>
        <RouteRow
          onClick={() => setOpenLocationSelectBox(!openLocationSelectBox)}
        >
          <RouteIcon>&#9998;</RouteIcon>
          <RouteLabel>edit existing system</RouteLabel>
        </RouteRow>
        {openLocationSelectBox && (
          <DropBoxWrapper>
            <LocationDropBox
              locations={locations}
              openLocationSelectBox={openLocationSelectBox}
              setOpenLocationSelectBox={setOpenLocationSelectBox}
              handleSelectedLocation={handleSelectedLocation}
            />
          </DropBoxWrapper>
        )}
      </RouteContainer>
    </Wrapper>
  );
};

export default SystemIdentificationChooser;

const Wrapper = styled.div`
  width: 827px;
  min-height: 100px;
  margin: 6px 0;

  ${layerA180Deg}

  border-radius: 16px;
  opacity: 1;
  ${justifyContentSpaceEvenly}
  align-items: flex-start;
  padding-top: 32px;
`;

const Route = styled.button`
  width: 300px;
  min-height: 48px;

  ${layerA180Deg}

  border-radius: 12px;
  opacity: 1;
  ${flexBoxCenter}
  flex-direction: column;
  cursor: pointer;
`;

const RouteContainer = styled.div`
  width: 300px;
  min-height: 48px;

  ${layerA180Deg}

  border-radius: 12px;
  opacity: 1;
  ${flexBoxCenter}
  flex-direction: column;
`;

const RouteRow = styled.div`
  width: 100%;
  height: 46px;
  ${flexBoxCenter}
  cursor: pointer;
`;

const RouteIcon = styled.span`
  width: 24px;
  height: 24px;
  margin-right: 10px;

  ${layerB}

  border-radius: 50%;
  color: #95ff45;
  font-size: 13px;
  ${flexBoxCenter}
`;

const RouteLabel = styled.span`
  font-size: 12px;
  letter-spacing: 1px;
  color: #ffffff;
`;

const DropBoxWrapper = styled.div`
  margin-bottom: 8px;
  ${flexBoxCenter}
`;
